/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

/*
 ================================================
 KEY CODES
 ================================================
 */
export const ESCAPE_CODE = 'Escape', ESCAPE_IE_CODE = 'Esc', ENTER_CODE = 'Enter', BACKSPACE_CODE = 'Backspace';


